import { DialogMod } from '@zawarski/eti-ui';

interface ConfirmDiscardDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

/** Unsaved-changes guard shown when closing an edit form with pending edits. */
const ConfirmDiscardDialog = ({ open, onOpenChange, onConfirm }: ConfirmDiscardDialogProps) => (
  <DialogMod
    open={open}
    onOpenChange={onOpenChange}
    title='Discard changes?'
    subtitle=''
    size='sm'
    leftBtnTitle='Keep editing'
    rightBtnTitle='Discard changes'
    rightBtnVariant='destructive'
    onClick={onConfirm}>
    <p className='rep:px-4 rep:py-4 rep:text-sm rep:text-muted-foreground'>
      Changes have been made. Closing the form now will lose them.
    </p>
  </DialogMod>
);

export default ConfirmDiscardDialog;
